/* istanbul ignore file */
import CONFIG from './config';

const { host, apiInterface } = CONFIG;

const PREFIX_URL = `${host}mutual-fund`;
const PREFIX_GAME_URL = `${PREFIX_URL}/games/wealth`;
const PREFIX_EXCLUSIVE = `${host}_exclusive`;
const PREFIX_EXCLUSIVE_MUTUAL_FUND = `${PREFIX_EXCLUSIVE}/mutual-fund`;

const endpoints = {
  investors: `${PREFIX_URL}/investors`,
  investor: `${PREFIX_URL}/investors/me`,
  investorStatus: `${PREFIX_URL}/investors/me/status`,
  signature: `${PREFIX_URL}/investors/signature`,
  registrationAttributes: `${PREFIX_URL}/investors/registration-attributes`,
  bankMappings: `${PREFIX_URL}/investors/bank-mappings`,
  transaction: `${PREFIX_URL}/transaction`,
  transactions: `${PREFIX_URL}/transactions`,
  transactionsInfos: `${PREFIX_URL}/transactions/infos`,
  mixTransactions: `${PREFIX_URL}/mix-transactions`,
  products: `${PREFIX_URL}/products`,
  portfolios: `${PREFIX_URL}/portfolios`,
  product: `${PREFIX_URL}/products`,
  subscription: `${PREFIX_URL}/transactions/subscribe`,
  recurrence: `${PREFIX_URL}/recurrences/template-details`,
  testimony: `${PREFIX_URL}/testimonies`,
  voucher: `${host}_exclusive/vouchers/usages`,
  video: `${PREFIX_URL}/videos`,
  disclaimer: `${PREFIX_URL}/disclaimers`,
  chooseAction: `${PREFIX_URL}/investors/choose-action`,
  alerts: `${PREFIX_URL}/alerts`,
  signatureToken: `${PREFIX_URL}/investors/signature/token`,
  virtualBanner: `${host}virtual-banners`,
  marks: `${PREFIX_URL}/investors/marks`,
  productsDanaTopups: `${PREFIX_URL}/products/dana-topups`,

  // FOR GAMES
  toggleInfo: `${PREFIX_GAME_URL}/infos`,
  summaries: `${PREFIX_GAME_URL}/summaries`,
  quests: `${PREFIX_GAME_URL}/quests`,
  missions: `${PREFIX_URL}/missions`,
  accessories: `${PREFIX_GAME_URL}/accessories`,
  toggleFeatures: `${host}_exclusive/info/toggle-features`,

  // PAYMENTS
  payments: `${PREFIX_EXCLUSIVE}/payments`,
  paymentChannels: `${PREFIX_EXCLUSIVE}/info/payments`,

  // EXCLUSIVE MUTUAL FUND
  bankChecks: `${PREFIX_EXCLUSIVE_MUTUAL_FUND}/investors/bank-checks`,
  authRedeem: `${PREFIX_EXCLUSIVE_MUTUAL_FUND}/clients/transactions/redemptions`,
  authUpdateInfo: `${PREFIX_EXCLUSIVE_MUTUAL_FUND}/clients/investors`,

  // Exclusive DANA
  danaProfile: `${PREFIX_EXCLUSIVE}/e-wallets/dana/profile`,
  danaConsultTopup: `${PREFIX_EXCLUSIVE}/e-wallets/dana/consult-topup`,

  // Neo Toggle
  neoToggles: `${host}_exclusive/neo/toggles`,
  neoConfig: `${PREFIX_EXCLUSIVE}/neo/configs`,

  userProfiles: `${host}user-profiles`,
  // ===== POSSIBLE DEPRECATED ENDPOINT START ====
  // Payment
  publicPayment: `${host}payments`,
  // USER
  usersTfaStatus: `${host}users/tfa-status`,
  // Track invoice register
  trackInvoiceRegister: `${host}offline-conversion-trackers/invoice-registers`,
  // Misc
  invoice: `${host}invoices`,
  articles: `${host}cms/websites`,
  wallet: `${host}wallet`,
  // ===== POSSIBLE DEPRECATED ENDPOINT END ====
};

const generateInterface = apiInterface.createGenerator('bukareksa', endpoints);

const interfaces = {
  createInvestor: generateInterface('post', 'investors', { withData: true }),
  updateInvestor: generateInterface('patch', 'investor', { withData: true }),
  updateInvestorStatus: generateInterface('patch', 'investorStatus', { withData: true }),
  getTransaction: generateInterface('get', 'transactions', { withId: true }),
  getTransactions: generateInterface('get', 'transactions', { withData: true }),
  getTransactionsInfos: generateInterface('get', 'transactionsInfos'),
  postMixTransactions: generateInterface('post', 'mixTransactions', { withData: true }),
  getProducts: generateInterface('get', 'products', { withData: true }),
  getProductsDanaTopups: generateInterface('get', 'productsDanaTopups'),
  getInvestor: generateInterface('get', 'investor'),
  getPortfolios: generateInterface('get', 'portfolios'),
  getPortfolioDetail: generateInterface('get', 'portfolios', { withId: true }),
  getInvoice: generateInterface('get', 'invoice', { withId: true }),
  getInvoices: generateInterface('get', 'invoice', { withData: true }),
  patchInvoices: generateInterface('patch', 'invoice', { withId: true, withData: true }),
  registerInvoices: generateInterface('post', 'invoice', { withData: true }),
  getProductNav: generateInterface('get', 'products', {
    withId: true,
    withData: true,
    appendUrl: 'navs',
  }),
  getProductDetail: generateInterface('get', 'product', { withId: true }),
  postSubscription: generateInterface('post', 'subscription', { withData: true }),
  registerRecurrence: generateInterface('post', 'recurrence', { withData: true }),
  getVoucherUsage: generateInterface('get', 'voucher', { withData: true }),
  getRegistrationAttributes: generateInterface('get', 'registrationAttributes'),
  getBankMappings: generateInterface('get', 'bankMappings'),
  getTestimonies: generateInterface('get', 'testimony'),
  getArticles: generateInterface('get', 'articles', {
    withId: true,
    withData: true,
    appendUrl: 'articles',
  }),
  getVideo: generateInterface('get', 'video'),
  getDisclaimer: generateInterface('get', 'disclaimer'),
  updateInvestorAction: generateInterface('put', 'chooseAction', { withData: true }),
  getAlerts: generateInterface('get', 'alerts'),
  getDigitalSignatureUrl: generateInterface('put', 'signature', { withData: true }),
  getDigitalSignatureImageUrl: generateInterface('get', 'signature', { withData: true }),
  getSignatureToken: generateInterface('get', 'signatureToken', { withData: true }),
  postSignature: generateInterface('post', 'signature', { withData: true }),
  getVirtualBanner: generateInterface('get', 'virtualBanner', { withData: true }),
  getMarks: generateInterface('get', 'marks', { withData: true }),
  putMarks: generateInterface('put', 'marks', { withData: true }),

  // FOR GAMES
  getToggleInfo: generateInterface('get', 'toggleInfo'),
  getSummaries: generateInterface('get', 'summaries', { withData: true }),
  getMissions: generateInterface('get', 'missions'),
  getQuests: generateInterface('get', 'quests'),
  putQuests: generateInterface('put', 'quests', {
    withId: true,
    withData: true,
    appendUrl: 'status',
  }),
  getAccessories: generateInterface('get', 'accessories'),

  getToggleFeatures: generateInterface('get', 'toggleFeatures', { withData: true }),
  getProductTermsAndCondition: generateInterface('get', 'products', {
    withId: true,
    withData: true,
    appendUrl: 'term-conditions',
  }),

  // PAYMENTS
  getPaymentDanaDetail: generateInterface('get', 'payments', { withId: true, appendUrl: 'dana' }),
  getPaymentChannels: generateInterface('get', 'paymentChannels'),
  postPaymentDana: generateInterface('post', 'payments', { withId: true, appendUrl: 'dana' }),
  postPaymentWallet: generateInterface('post', 'publicPayment', { withId: true, appendUrl: 'wallet' }),

  // USER
  getCurrentUser: generateInterface('get', 'userProfiles'),
  putTfaStatus: generateInterface('put', 'usersTfaStatus', { withData: true }),

  // EXCLUSIVE MUTUAL FUND
  checkBankValidity: generateInterface('post', 'bankChecks', { withData: true }),
  createRedeemTransactions: generateInterface('post', 'authRedeem', { withData: true }),
  patchAuthInvestor: generateInterface('patch', 'authUpdateInfo', { withData: true }),

  // Track invoice register
  trackInvoiceRegister: generateInterface('post', 'trackInvoiceRegister', { withData: true }),

  // Exclusive DANA
  getDanaProfile: generateInterface('get', 'danaProfile'),
  getDanaConsultTopup: generateInterface('get', 'danaConsultTopup'),

  // Misc
  getWallet: generateInterface('get', 'wallet'),

  // Neo Toggle
  getNeoToggles: generateInterface('post', 'neoToggles', { withData: true }),
  getNeoConfig: generateInterface('post', 'neoConfig', { withData: true }),
};

export default interfaces;
